import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Link as MuiLink,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export type LoginFormValues = {
  email: string;
  password: string;
};

type Props = {
  onSubmit: (values: LoginFormValues) => void;
  errorMessage?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
};

export default function LoginForm({
  onSubmit,
  isLoading,
  isDisabled,
  errorMessage,
}: Props) {
  const { t } = useTranslation();
  const {
    handleSubmit,
    register,
    formState: { errors, isValid, isSubmitted },
  } = useForm<LoginFormValues>();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl isInvalid={!isValid && isSubmitted}>
        <Box flexGrow={1} mb={4} display="flex" flexDirection="column">
          <FormLabel htmlFor="email">{t("forms.email")}</FormLabel>
          <Input
            id="email"
            step="1"
            placeholder="Email"
            {...register("email", {
              required: t("forms.validation.required"),
            })}
          />
          <FormErrorMessage>
            {errors.email && errors.email.message}
          </FormErrorMessage>
        </Box>
        <Box flexGrow={1} mb={4}>
          <FormLabel htmlFor="password">{t("forms.password")}</FormLabel>
          <Input
            id="password"
            type="password"
            step="1"
            placeholder="Password"
            {...register("password", {
              required: t("forms.validation.required"),
            })}
          />
          <FormErrorMessage>
            {errors.password && errors.password.message}
          </FormErrorMessage>
        </Box>
        <Text color="red">{errorMessage}</Text>
        <Box justifyContent="flex-end" display="flex" flexGrow={1} mx={2}>
          <MuiLink
            as={Link}
            to="/sign-up"
            textAlign="right"
            color={"primary.DEFAULT"}
          >
            {t("login_page.sign_up")}
          </MuiLink>
        </Box>
        <VStack>
          <Button
            alignSelf="stretch"
            mt={4}
            bg="primary.DEFAULT"
            color="white"
            type="submit"
            isLoading={isLoading}
            isDisabled={isDisabled}
          >
            {t("common.buttons.confirm")}
          </Button>
        </VStack>
      </FormControl>
    </form>
  );
}
